import { initialState } from './agency-details-store.state';
import * as AgencyDetailsActions from './agency-details-store.actions';
import { createReducer, on } from '@ngrx/store';
import { ActionType, AgencyActionResult } from '../models/agency-action-result.models';

export const AgencyDetailsReducer = createReducer(
  initialState,
  on(AgencyDetailsActions.fetchAgencyDetails, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(AgencyDetailsActions.fetchAgencyDetailsSuccess, (state, { agencyDetails }) => {
    return {
      ...state,
      currentAgency: agencyDetails,
      uid: agencyDetails.uidIdentifier ?? agencyDetails.uid,
      isLoading: false,
    };
  }),
  on(AgencyDetailsActions.fetchAgencySettings, (state) => {
    return {
      ...state,
      settings: null,
    };
  }),
  on(AgencyDetailsActions.fetchAgencySettingsSuccess, (state, { settings }) => {
    return {
      ...state,
      settings: settings,
    };
  }),
  on(AgencyDetailsActions.fetchAgencyCategoriesSuccess, (state, { categories }) => {
    return {
      ...state,
      categoriesList: categories,
    };
  }),
  on(AgencyDetailsActions.updateAgencyPhoto, (state) => {
    return {
      ...state,
      isImageLoading: true,
    };
  }),
  on(AgencyDetailsActions.updateAgencyPhotoSuccess, (state, { newUrl }) => {
    if (state.currentAgency) {
      return {
        ...state,
        currentAgency: {
          ...state.currentAgency,
          pictureFullPath: newUrl,
        },
        isImageLoading: false,
      };
    }

    return state;
  }),
  on(AgencyDetailsActions.updateAgencyPhotoFailure, (state) => {
    return {
      ...state,
      isImageLoading: false,
    };
  }),
  on(AgencyDetailsActions.updateAgencyDetailsSuccess, (state, { details }) => {
    if (state.currentAgency) {
      return {
        ...state,
        currentAgency: {
          ...state.currentAgency,
          emailAddress: details.emailAddress,
          name: details.name,
          shortName: details.shortName,
          phone: details.phone,
          address: details.address,
        },
        actionResult: new AgencyActionResult(ActionType.UpdateAgencyDetails, null, true),
      };
    }

    return state;
  }),

  on(AgencyDetailsActions.updatePointOfContactSuccess, (state, { details }) => {
    if (state.currentAgency) {
      return {
        ...state,
        currentAgency: {
          ...state.currentAgency,
          primaryContact: details.primaryContact,
          secondaryContact: details.secondaryContact,
        },
      };
    }

    return state;
  }),
  on(AgencyDetailsActions.updateAgencySettingsSuccess, (state, { settings }) => {
    if (state.currentAgency) {
      return {
        ...state,
        settings: settings,
        currentAgency: {
          ...state.currentAgency,
          canDownloadClient: settings.canDownloadClient,
          canSelectiveUpload: settings.canSelectiveUpload,
          isLoginPinRequired: settings.isLoginPinRequired,
        },
      };
    }

    return state;
  }),
  on(AgencyDetailsActions.addNewAgencyCategorySuccess, (state, { category }) => {
    if (state.categoriesList) {
      if (!category.isDefault) {
        return {
          ...state,
          categoriesList: [...state.categoriesList, category],
        };
      }

      const previousIsDefaultCategory = [...state.categoriesList].find((i) => i.isDefault);

      return {
        ...state,
        categoriesList: [
          ...(previousIsDefaultCategory ? state.categoriesList.map((x) => (x.uid !== previousIsDefaultCategory.uid ? x : { ...x, isDefault: false })) : state.categoriesList),
          category,
        ],
      };
    }

    return state;
  }),
  on(AgencyDetailsActions.updateAgencyCategorySuccess, (state, { category }) => {
    if (state.categoriesList) {
      if (!category.isDefault) {
        return {
          ...state,
          categoriesList: state.categoriesList.map((x) => (x.uid !== category.uid ? x : category)),
          actionResult: new AgencyActionResult(ActionType.UpdateAgencyCategory, null, true),
        };
      }

      const previousIsDefaultCategory = [...state.categoriesList].find((i) => i.isDefault);
      const updatedCategoryList = [
        ...(previousIsDefaultCategory ? state.categoriesList.map((x) => (x.uid !== previousIsDefaultCategory.uid ? x : { ...x, isDefault: false })) : state.categoriesList),
      ];

      return {
        ...state,
        categoriesList: updatedCategoryList.map((x) => (x.uid !== category.uid ? x : category)),
        actionResult: new AgencyActionResult(ActionType.UpdateAgencyCategory, null, true),
      };
    }

    return state;
  }),
  on(AgencyDetailsActions.deleteAgencyCategorySuccess, (state, { uid }) => {
    if (state.categoriesList) {
      return {
        ...state,
        categoriesList: state.categoriesList.filter((x) => x.uid !== uid),
      };
    }

    return state;
  }),
  on(AgencyDetailsActions.updateAgencyDetailsActionResult, (state, { actionResult }) => {
    return {
      ...state,
      actionResult: actionResult,
    };
  }),
  on(AgencyDetailsActions.updateAgencyCategoryActionResult, (state, { actionResult }) => {
    return {
      ...state,
      actionResult: actionResult,
    };
  })
);
